import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
  POLYGON_TYPE,
  POLY_COUNT,
} from 'Pods/ThreeDStudio/Store/constants'

export default {
  "model_id": MODEL_ID.TENCENT_MESH_SIMPLIFICATION_PRO,
  "provider": PROVIDER.TENCENT,
  "action": ACTION.MESH_SIMPLIFICATION,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_3d": {
        "type": "string",
        "allowedTypes": ['glb', 'obj'],
        "maxFileSize": 200 * 1024 * 1024,
      },
      "polygon_type": {
        "type": "string",
        "enum": [POLYGON_TYPE.TRIANGLE, POLYGON_TYPE.QUADRILATERAL],
        "default": POLYGON_TYPE.TRIANGLE,
      },
      "face_level": {
        "type": "string",
        "enum": [POLY_COUNT.HIGH, POLY_COUNT.MEDIUM, POLY_COUNT.LOW],
        "default": POLY_COUNT.MEDIUM,
      },
    },
    "required": ["input_3d"],
    "additionalProperties": false,
  },
  "ui_schema": {
    "face_level": {
      "ui:options": {
        "slider_disabled": true,
      },
    },
  },
  "active_if": {
    "properties": {
      "smart_low_poly": { "const": true },
    },
  },
}
